import { getRecurrenceDisplayText } from '@akin-home/recurrence';
import { CalendarItemUnion } from '../types';

export const getCalendarItemRecurrenceText = <T extends CalendarItemUnion>(
  item: T
): string => {
  if (item.isRecurrence && item.origin?.recurrence) {
    return getRecurrenceDisplayText(item.origin.start, item.origin.recurrence);
  } else if (item.recurrence) {
    return getRecurrenceDisplayText(item.start, item.recurrence);
  } else {
    return 'Does not repeat';
  }
};
